import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogClose, MatDialogModule } from "@angular/material/dialog";
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-recent-and-fav-estimate-settings',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDialogClose,
    MatDialogModule,
    TranslatePipe
],
  templateUrl: './recent-and-fav-estimate-settings.component.html',
  styleUrl: './recent-and-fav-estimate-settings.component.scss'
})

export class RecentAndFavEstimateSettingsComponent {
  settingsForm: FormGroup<{
    estimateDisplay: FormControl<number>;
    favouriteEstimateDisplay: FormControl<number>;
  }>;

  constructor(private readonly fb: FormBuilder) {
    this.settingsForm = this.fb.group({
      estimateDisplay: this.fb.control<number>(5, [Validators.min(4), Validators.max(12)]),
      favouriteEstimateDisplay: this.fb.control<number>(5, [Validators.min(0), Validators.max(4)])
    });
  }

  onSubmit() {
    if (this.settingsForm.valid) {
      const settings = this.settingsForm.value;
      localStorage.setItem('estimateSettings', JSON.stringify(settings));
      }
  }
}